<app-address-component [form]="form" [subways]="data.subways" [highways]="data.highways"></app-address-component>

<button (click)="saveForm()" [disabled]="!form.value['address'].label" type="button" class="button">
  Сохранить
</button>
